import Vue from 'vue'

export default function remember_token({ from, next, router, to }) {
    if (to.query.access_token){
        Vue.cookie.set('access_token', to.query.access_token)
        
        return next();
    } else {
        return next();
    }

  }